import React from "react";
import classNames from "classnames";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import { ScrollBar } from "components/ui";
import VerticalMenuContent from "components/VerticalMenuContent";

import {
  SIDE_NAV_WIDTH,
  SIDE_NAV_COLLAPSED_WIDTH,
  NAV_MODE_THEMED,
  HEADER_HEIGHT_CLASS,
} from "constants/theme.constant";
import navigationConfig from "configs/navigation.config";
import useResponsive from "utils/hooks/useResponsive";

import { ReactComponent as SideMenuLogo } from "assets/svg/WISE_Logo_dark.svg";

const sideNavStyle = {
  width: SIDE_NAV_WIDTH,
  minWidth: SIDE_NAV_WIDTH,
};

const sideNavCollapseStyle = {
  width: SIDE_NAV_COLLAPSED_WIDTH,
  minWidth: SIDE_NAV_COLLAPSED_WIDTH,
};

const SideNav = () => {
  const themeColor = useSelector(({ theme }) => theme.themeColor);
  const primaryColorLevel = useSelector(({ theme }) => theme.primaryColorLevel);
  const navMode = useSelector(({ theme }) => theme.navMode);
  const direction = useSelector(({ theme }) => theme.direction);
  const sideNavCollapse = useSelector(
    ({ theme }) => theme.layout.sideNavCollapse,
  );

  const currentRouteKey = useSelector(
    ({ base }) => base.common.currentRouteKey,
  );

  const userAuthority = useSelector(({ auth }) => [auth.user.role]);
  const adminPermissions = useSelector(
    ({ auth }) => auth.user.adminPermissions,
  );

  const { larger } = useResponsive();

  const sideNavColor = () => {
    if (navMode === NAV_MODE_THEMED) {
      return `bg-${themeColor}-${primaryColorLevel} side-nav-${navMode}`;
    }
    return `side-nav-${navMode}`;
  };

  const menuContent = (
    <VerticalMenuContent
      navMode={navMode}
      collapsed={sideNavCollapse}
      navigationTree={navigationConfig}
      routeKey={currentRouteKey}
      userAuthority={userAuthority}
      permissions={adminPermissions}
      direction={direction}
    />
  );

  return (
    <>
      {larger.md && (
        <div
          style={sideNavCollapse ? sideNavCollapseStyle : sideNavStyle}
          className={classNames(
            "side-nav",
            sideNavColor(),
            !sideNavCollapse && "side-nav-expand",
          )}
        >
          <div
            className={classNames(
              sideNavCollapse && "flex justify-center",
              "side-nav-header",
            )}
          >
            <SideMenuLogo
              className={classNames(
                sideNavCollapse ? "w-3/4" : "w-3/5",
                HEADER_HEIGHT_CLASS,
              )}
            />
          </div>
          {sideNavCollapse ? (
            menuContent
          ) : (
            <div className="side-nav-content">
              <ScrollBar autoHide direction={direction}>
                {menuContent}
              </ScrollBar>
            </div>
          )}
        </div>
      )}
    </>
  );
};

SideNav.propTypes = {
  themed: PropTypes.bool,
  darkMode: PropTypes.bool,
  themeColor: PropTypes.string,
};

SideNav.defaultProps = {
  themed: false,
  darkMode: false,
  themeColor: "",
};

export default SideNav;
